import {tagColors} from "@/components/tag/tag-colors";
export const DeliveryOrderEnum = {
  status: {
    waitInbound: 'waitInbound',
    inInbound: 'inInbound',
    completed: 'completed',
    abolished: 'abolished',
  },
  statusOption: [
    { id: 'waitInbound', text: '待入库',...tagColors.orange},
    { id: 'inInbound', text: '入库中',...tagColors.blue},
    { id: 'completed', text: '已完成',...tagColors.green},
    { id: 'abolished', text: '已作废',...tagColors.lightGray}
  ],
  settleOption: [
    { id: 'monthly', text: '月结',...tagColors.blueDark},
    { id: 'cash', text: '现结',...tagColors.orangeDark},
  ],
  logColumns: [
    {id: 'createDate', header: '操作时间', field: 'createTime', minWidth: '120px'},
    {id: 'opUser', header: '操作用户', field: 'createUserName', minWidth: '100px'},
    {id: 'op', header: '操作分类', field: 'option:op', options: [
        {id: 'save', text: '新增'},
        {id: 'update', text: '更新'},
        {id: 'abolished', text: '作废'},
        {id: 'updateActualDeliveryDate', text: '修改实际交货日期'},
      ],
      minWidth: '120px'},
    {id: 'content', header: '操作内容', field: 'content', overflowLine: 2, minWidth: '300px'}
  ]
};
